import {NgModule} from '@angular/core';
import {SignUpComponent} from './signup/sign-up.component';
import {LoginComponent} from './login/login.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {DirectiveModule} from '../../modules/directives/directive.module';
import {WidgetModule} from '../../modules/widget/widget.module';
import {ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {FlexLayoutModule, FlexModule} from '@angular/flex-layout';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../../modules/shared/shared.module';
import {AuthRoutingModule} from './auth.routing.module';
import {MatIconModule} from '@angular/material/icon';
import {InputTextModule} from 'primeng/inputtext';
import {YouTubePlayerModule} from '@angular/youtube-player';
import {MatCardModule} from '@angular/material/card';

import {CertificatTableComponent} from './certificat-table/certificat-table.component';
import {CertificatPageComponent} from './certificat-page/certificat-page.component';
import {MatTableModule} from '@angular/material/table';
import {PipeModule} from 'src/app/modules/pipes/pipe.module';
import {TranslateModule} from '@ngx-translate/core';
import {CertificatDetailsComponent} from './certificat-details/certificat-details.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatMenuModule} from '@angular/material/menu';
import {ListUsersLoginComponent} from './certificat-page/list-users-login/list-users-login.component';

const components = [SignUpComponent, LoginComponent];

@NgModule({
    imports: [
        AuthRoutingModule,
        MatFormFieldModule,
        MatDatepickerModule,
        DirectiveModule,
        WidgetModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        FlexModule,
        RouterModule,
        SharedModule,
        MatIconModule,
        InputTextModule,
        YouTubePlayerModule,
        MatCardModule,
        FlexLayoutModule,
        MatTableModule,
        MatCardModule,
        PipeModule,
        MatDialogModule,
        TranslateModule,
        MatToolbarModule,
        MatMenuModule,
    ],
    declarations: [
        CertificatDetailsComponent,
        CertificatTableComponent,
        CertificatPageComponent,
        ListUsersLoginComponent,
        ...components,
    ],
    exports: [...components, CertificatPageComponent],
})
export class AuthModule {
}
